import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LibFindPlayerModalComponent } from '@libs/client';
import { SearchAthleteResponse } from '@libs/entity-lib';
import { FindPlayerOpener, FindPlayerOpenOptions, FindPlayerResult } from '@libs/util-services';

@Injectable({ providedIn: 'root' })
export class LessorFindPlayerOpener implements FindPlayerOpener {
  private readonly modalCtrl = inject(ModalController);

  async open(options?: FindPlayerOpenOptions): Promise<FindPlayerResult> {
    const modal = await this.modalCtrl.create({
      component: LibFindPlayerModalComponent,
      cssClass: 'find-player-modal modal-fullscreen',
      componentProps: {
        initialSegment: options?.initialSegment,
        initialPhone: options?.initialPhone,
      },
    });
    await modal.present();
    const { data } = await modal.onWillDismiss<
      SearchAthleteResponse | { action: 'register' } | null
    >();
    if (data && 'action' in data && data.action === 'register') {
      return { kind: 'register-requested' };
    }
    if (data && 'idAtleta' in data) {
      return { kind: 'selected', athlete: data };
    }
    return { kind: 'cancelled' };
  }
}
